import type { FC } from 'react'

import getConfig from 'next/config'
import Script from 'next/script'

import type { IAPI_Channel } from '@core/api'
import { pruneNilValues } from '@core/object'
import {
  getFwnDataAttributesObject,
  getFwnModuleScriptUrl,
  getFwnScriptUrl,
} from '@microsites/utils/fwnScript'

const { publicRuntimeConfig } = getConfig()

interface Props {
  channel: IAPI_Channel['channel'] | undefined
}

/**
 *
 */
export const FWNScript: FC<Props> = ({ channel }) => {
  const { fwnGlobalConfig, fwnHost } = publicRuntimeConfig
  const fwnConfig = pruneNilValues({
    ...fwnGlobalConfig,
    channel: channel?.username,
  })

  return (
    <>
      <Script
        src={getFwnModuleScriptUrl(fwnHost)}
        type="module"
        strategy="beforeInteractive"
        {...getFwnDataAttributesObject(fwnConfig)}
      />
      <Script
        src={getFwnScriptUrl(fwnHost)}
        noModule
        strategy="beforeInteractive"
        {...getFwnDataAttributesObject(fwnConfig)}
      />
    </>
  )
}
